import { connect } from 'redaction'
import cx from 'classnames'
import cssModules from 'react-css-modules'
import { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import { isMobile } from 'react-device-detect'
import { BigNumber } from 'bignumber.js'
import moment from 'moment'
import actions from 'redux/actions'
import appConfig from 'app-config'
import { links, constants, stats, user, routing } from 'helpers'
import { localisedUrl } from 'helpers/locale'
import config from 'helpers/externalConfig'
import metamask from 'helpers/metamask'
import wpLogoutModal from 'helpers/wpLogoutModal'
import feedback from 'helpers/feedback'

// import InvoicesList from 'pages/Invoices/InvoicesList'
import History from 'pages/History/History'
import DashboardLayout from 'components/layout/DashboardLayout/DashboardLayout'
import BalanceForm from 'components/BalanceForm/BalanceForm'
import kasaIndexPrice from 'helpers/kasaIndexPrice'
import kasaCurrencyRate from 'helpers/kasaCurrencyRate'
import { getLocal, setLocal } from '@walletconnect/utils'



import styles from './SellIntro.scss'

import QuickSwapIcon from './images/qswap.png'
import BankIcon from './images/bank.svg'
import RangoIcon from './images/rango.png'
import TokenIcon from './images/token.svg'

const host = window.location.hostname || document.location.host
const isWidgetBuild = config && config.isWidget


@connect(
  ({
    core: { hiddenCoinsList },
    user: {
      activeFiat,
      ethData,
      bnbData,
      maticData,
      arbethData,
      aurethData,
      xdaiData,
      ftmData,
      movrData,
      oneData,
      ameData,
      avaxData,
      btcData,
      ghostData,
      nextData,
      phiData,
      tokensData,
      btcMultisigSMSData,
      btcMultisigUserData,
      btcMultisigUserDataList,
      isBalanceFetching,
      multisigPendingCount,
      activeCurrency,
      metamaskData,
    },
    currencies: { items: currencies },
    modals,
  }) => {
    const userCurrencyData = [
      ethData,
      bnbData,
      maticData,
      arbethData,
      aurethData,
      xdaiData,
      ftmData,
      avaxData,
      movrData,
      oneData,
      ameData,
      btcData,
      ghostData,
      nextData,
      phiData,
      ...Object.keys(tokensData).map((k) => tokensData[k]),
    ]

    return {
      userCurrencyData,
      currencies,
      isBalanceFetching,
      multisigPendingCount,
      hiddenCoinsList,
      user,
      activeCurrency,
      activeFiat,
      coinsData: {
        ethData,
        bnbData,
        maticData,
        arbethData,
        aurethData,
        xdaiData,
        ftmData,
        avaxData,
        movrData,
        oneData,
        ameData,
        phiData,
        metamaskData: {
          ...metamaskData,
          currency: 'ETH Metamask',
        },
        btcData,
        ghostData,
        nextData,
        btcMultisigSMSData,
        btcMultisigUserData,
        btcMultisigUserDataList,
      },
      modals,
    }
  },
)
@withRouter
@cssModules(styles, { allowMultiple: true }) @cssModules(styles, { allowMultiple: true })
class SellIntro extends PureComponent<any, any> {
  syncTimer: ReturnType<typeof setTimeout> | null = null

  constructor(props) {
    super(props)

    const {
      match: {
        params: { page = null },
      },
      multisigPendingCount,
    } = props

    let activeComponentNum = 0

    if (page === 'history' && !isMobile) {
      activeComponentNum = 1
    }
    if (page === 'invoices') {
      // activeComponentNum = 2
      activeComponentNum = 1
    }

    this.state = {
      activeComponentNum,
      btcBalance: 0,
      enabledCurrencies: user.getActivatedCurrencies(),
      multisigPendingCount,
    }
  }

  handleConnectWallet() {
    const {
      history,
      intl: { locale },
    } = this.props

    if (metamask.isConnected()) {
      history.push(localisedUrl(locale, links.home))
      return
    }

    setTimeout(() => {
      metamask.connect({})
    }, 100)
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { page: prevPage = null },
      },
      multisigPendingCount: prevMultisigPendingCount,
      location: { pathname: prevPathname },
    } = prevProps

    const {
      match: {
        params: { page = null },
      },
      multisigPendingCount,
      intl,
      intl: { locale },
      location: { pathname },
      history,
    } = this.props

    if (
      pathname.toLowerCase() !== prevPathname.toLowerCase()
      && pathname.toLowerCase() === links.connectWallet.toLowerCase()
    ) {
      this.handleConnectWallet()
    }

    if (page !== prevPage || multisigPendingCount !== prevMultisigPendingCount) {
      let activeComponentNum = 0

      if (page === 'history' && !isMobile) activeComponentNum = 1
      // if (page === 'invoices') activeComponentNum = 2
      if (page === 'invoices') activeComponentNum = 1

      if (page === 'exit') {
        wpLogoutModal(() => {
          history.push(localisedUrl(locale, links.home))
        }, intl)
      }

      this.setState(() => ({
        activeComponentNum,
        multisigPendingCount,
      }))
    }
    // @ts-ignore
    clearTimeout(this.syncTimer)
  }

  componentDidMount() {
    const {
      match: {
        params,
        params: { page },
        url,
      },
      multisigPendingCount,
      history,
      location: { pathname },
      intl,
      intl: { locale },
    } = this.props

    if (pathname.toLowerCase() === links.connectWallet.toLowerCase()) {
      this.handleConnectWallet()
    }

    actions.user.getBalances()

    // actions.user.fetchMultisigStatus()

    if (url.includes('send')) {
      this.handleWithdraw(params)
    }

    if (page === 'exit') {
      wpLogoutModal(() => {
        history.push(localisedUrl(locale, links.home))
      }, intl)
    }
    this.getInfoAboutCurrency()
    this.setState({
      multisigPendingCount,
    })
  }

  getInfoAboutCurrency = async () => {
    const { currencies } = this.props
    const currencyNames = currencies.map(({ value, name }) => value || name)

    await actions.user.getInfoAboutCurrency(currencyNames)
  }

  handleWithdraw = (params) => {
    const { userCurrencyData } = this.state
    const { address, amount } = params
    const item = userCurrencyData.find(
      ({ currency }) => currency.toLowerCase() === params.currency.toLowerCase(),
    )

    actions.modals.open(constants.modals.Withdraw, {
      ...item,
      toAddress: address,
      amount,
    })
  }

  goToСreateWallet = () => {
    feedback.wallet.pressedAddCurrency()
    const {
      history,
      intl: { locale },
    } = this.props

    history.push(localisedUrl(locale, links.createWallet))
  }

  handleReceive = (context) => {
    const widgetCurrencies = user.getWidgetCurrencies()
    const filteredCurrencies = user.filterUserCurrencyData(actions.core.getWallets())

    const availableWallets = filteredCurrencies.filter((item) => {
      const { isMetamask, isConnected, currency, balance } = item

      return (
        (context !== 'Send' || balance)
        && (!isMetamask || (isMetamask && isConnected))
        && (!isWidgetBuild || widgetCurrencies.includes(currency))
      )
    })

    actions.modals.open(constants.modals.CurrencyAction, {
      currencies: availableWallets,
      context,
    })
  }

  showNoWalletsNotification = () => {
    actions.notifications.show(
      constants.notifications.Message,
      {
        message: (
          <FormattedMessage
            id="WalletEmptyBalance"
            defaultMessage="No wallets available"
          />
        ),
      },
    )
  }

  handleWithdrawFirstAsset = () => {
    const {
      history,
      intl: { locale },
    } = this.props
    const userCurrencyData = actions.core.getWallets({})
    const availableWallets = user.filterUserCurrencyData(userCurrencyData)

    if (
      !Object.keys(availableWallets).length
      || (Object.keys(availableWallets).length === 1 && !user.isCorrectWalletToShow(availableWallets[0]))
    ) {
      this.showNoWalletsNotification()
      return
    }

    const firstAvailableWallet = availableWallets.find((wallet) => wallet.currency.toLowerCase() === 'kaxaa')

    // const firstAvailableWallet = availableWallets.find((wallet) => (
    //   user.isCorrectWalletToShow(wallet)
    //   && !wallet.balanceError
    //   && new BigNumber(wallet.balance).isPositive()
    // ))

    if (!firstAvailableWallet) {
      this.showNoWalletsNotification()
      return
    }

    const { currency, address, tokenKey } = firstAvailableWallet
    let targetCurrency = currency

    switch (currency.toLowerCase()) {
      case 'btc (multisig)':
      case 'btc (sms-protected)':
      case 'btc (pin-protected)':
        targetCurrency = 'btc'
    }

    const firstUrlPart = tokenKey ? `/token/${tokenKey}` : `/${targetCurrency}`

    history.push(
      localisedUrl(locale, `${firstUrlPart}/${address}/send`),
    )
  }

  returnFiatBalanceByWallet = (wallet) => {
    const hasFiatPrice = wallet.balance > 0 && wallet.infoAboutCurrency?.price_fiat

    if (hasFiatPrice) {
      return new BigNumber(wallet.balance)
        .multipliedBy(wallet.infoAboutCurrency.price_fiat)
        .dp(2, BigNumber.ROUND_FLOOR)
        .toNumber()
    }

    return 0
  }

  addFiatBalanceInUserCurrencyData = (currencyData) => {
    currencyData.forEach((wallet) => {
      wallet.fiatBalance = this.returnFiatBalanceByWallet(wallet)
    })

    return currencyData
  }

  returnBalanceInBtc = (wallet) => {
    const widgetCurrencies = user.getWidgetCurrencies()
    const name = wallet.isToken
      ? wallet.tokenKey.toUpperCase()
      : (wallet.currency || wallet.name)

    if (
      (!isWidgetBuild || widgetCurrencies.includes(name))
      && !wallet.balanceError
      && wallet.infoAboutCurrency?.price_btc
      && wallet.balance > 0
    ) {
      return wallet.balance * wallet.infoAboutCurrency.price_btc
    }

    return 0
  }

  returnTotalBalanceInBtc = (currencyData) => {
    let balance = new BigNumber(0)

    currencyData.forEach((wallet) => {
      balance = balance.plus(this.returnBalanceInBtc(wallet))
    })

    return balance.toNumber()
  }

  returnKaxaaBalance = (currencyData) => {
    let balanceKaxaa = 0

    currencyData.forEach((wallet) => {
      if (wallet.currency === 'KAXAA') {
        balanceKaxaa = wallet.balance && wallet.balance > 0 && wallet.balance
      }
    })

    setLocal('kaxa:balance', balanceKaxaa)
    return balanceKaxaa
  }

  returnTotalFiatBalanceByCustomKaxaaAPI = (currencyData) => {
    // const allowedTokens = ['{matic}matic', '{matic}usdc', '{matic}kaxaa']
    let balance = new BigNumber(0)
    const currencyRate = getLocal('kaxa:rate') || []
    const kaxaIndexPrice = getLocal('kaxa:index')

    if (currencyData.length > 0 && currencyRate.length > 0) {
      currencyData.forEach((wallet) => {
        console.log('wallet', wallet);
        if (wallet.tokenKey === '{matic}kaxaa' && kaxaIndexPrice) {
          balance = balance.plus(kaxaIndexPrice * wallet.balance)
        } else {
          balance = balance.plus(wallet.fiatBalance)
          // currencyRate.forEach((item) => {
          //   if (item.coin === wallet.currency && wallet.tokenKey) {
          //     balance = balance.plus(item.rate * wallet.balance)
          //     //  console.log('wallet', wallet, 'wallet.currency', wallet.currency, 'item.rate', item.rate, 'wallet.balance', wallet.balance, 'fiat', item.rate * wallet.balance)
          //   }
          // })
        }
      })
    }

    return balance.toNumber()
  }


  returnTotalFiatBalance = (currencyData) => {
    let balance = new BigNumber(0)

    currencyData.forEach((wallet) => {
      balance = balance.plus(wallet.fiatBalance)
    })

    return balance.toNumber()
  }

  syncData = () => {
    // that is for noxon, dont delete it :)
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isOneHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(1, 'hours'),
    )

    const { coinsData, coinsData: ethData } = this.props

    this.syncTimer = setTimeout(async () => {
      if (host === 'localhost' || config?.entry !== 'mainnet' || !metamask.isCorrectNetwork()) {
        return
      }

      if (isOneHourAfter || isFirstCheck) {
        localStorage.setItem(constants.localStorage.lastCheckBalance, now)
        try {
          const ipInfo = await stats.getIPInfo()

          const registrationData: {
            locale: string
            ip: string
            widget_url?: string
            wallets?: IUniversalObj[]
          } = {
            locale:
              ipInfo.locale
              || (navigator.userLanguage || navigator.language || 'en-gb').split('-')[0],
            ip: ipInfo.ip,
          }

          let widgetUrl
          if (appConfig.isWidget) {
            widgetUrl = routing.getTopLocation().origin

            registrationData.widget_url = widgetUrl
          }

          const tokensArray: any[] = Object.values(coinsData)

          const wallets = tokensArray.map((item) => ({
            symbol: item && item.currency ? item.currency.split(' ')[0] : '',
            type: item && item.currency ? item.currency.split(' ')[1] || 'common' : '',
            address: item && item.address ? item.address : '',
            balance: item && item.balance ? new BigNumber(item.balance).toNumber() : 0,
            public_key: item && item.publicKey ? item.publicKey.toString('Hex') : '',
            entry: config?.entry ? config.entry : 'testnet:undefined',
          }))

          registrationData.wallets = wallets

          await stats.updateUser(ethData.address, routing.getTopLocation().host, registrationData)
        } catch (error) {
          console.group('wallet >%c syncData', 'color: red;')
          console.error(`Sync error in wallet: ${error}`)
          console.groupEnd()
        }
      }
    }, 2000)
  }

  syncKaxaaIndexPrice = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckBalance) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isTenHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(10, 'hours'),
    )

    if (isTenHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckBalance, now)
      try {
        const kaxaaIndexPrice = await kasaIndexPrice.getKaxaaIndexPrice()
        setLocal('kaxa:index', kaxaaIndexPrice)
      } catch (error) {
        console.group('wallet >%c index price kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa index price: ${error}`)
        console.groupEnd()
      }
    }
  }

  syncKaxaaCurrencyRate = async () => {
    const now = moment().format('HH:mm:ss DD/MM/YYYY')
    const lastCheck = localStorage.getItem(constants.localStorage.lastCheckCurrencyRate) || now
    const lastCheckMoment = moment(lastCheck, 'HH:mm:ss DD/MM/YYYY')

    const isFirstCheck = moment(now, 'HH:mm:ss DD/MM/YYYY').isSame(lastCheckMoment)
    const isSixHourAfter = moment(now, 'HH:mm:ss DD/MM/YYYY').isAfter(
      lastCheckMoment.add(6, 'hours'),
    )

    if (isSixHourAfter || isFirstCheck) {
      localStorage.setItem(constants.localStorage.lastCheckCurrencyRate, now)
      try {
        const kaxaaCurrencyRate = await kasaCurrencyRate.kasaCurrencyRate()
        setLocal('kaxa:rate', kaxaaCurrencyRate)
      } catch (error) {
        console.group('wallet >%c currency rate kaxaa', 'color: red;')
        console.error(`Sync error in kaxaa currency rate: ${error}`)
        console.groupEnd()
      }
    }
  }

  render() {
    const {
      activeComponentNum,
      multisigPendingCount,
    } = this.state

    const {
      hiddenCoinsList,
      isBalanceFetching,
      activeFiat,
      activeCurrency,
      match: {
        params: { page = null },
      },
    } = this.props

    if (!config.isWidget || window?.STATISTICS_ENABLED) {
      this.syncData()
    }

    this.syncKaxaaIndexPrice()
    this.syncKaxaaCurrencyRate()

    const allWallets = actions.core.getWallets({})
    let userWallets = user.filterUserCurrencyData(allWallets)

    userWallets = this.addFiatBalanceInUserCurrencyData(userWallets)

    // save KAXAA balance in localstorage to use in GetKax page
    this.returnKaxaaBalance(userWallets)

    // const balanceInBtc = this.returnTotalBalanceInBtc(userWallets) // TODO:: for now not showing collective btc balance
    // const allFiatBalance = this.returnTotalFiatBalance(userWallets) // TODO:: need to check USD aka Fiat balance calculation
    const allFiatBalanceByKaxaaCurrencyRateApi = this.returnTotalFiatBalanceByCustomKaxaaAPI(userWallets) // kaxa:balance

    const kaxaaIndex = getLocal('kaxa:index')
    let totalCurrencyBalanceInKaxaa = 0
    if (kaxaaIndex) {
      totalCurrencyBalanceInKaxaa = allFiatBalanceByKaxaaCurrencyRateApi / kaxaaIndex
    }
    // const allFiatBalance = kaxaaIndex * kaxaaBalance // kaxaaBalanceInUSD // only for kaxaa

    return (
      <DashboardLayout
        page={page}
        BalanceForm={(
          <BalanceForm
            activeFiat={activeFiat}
            fiatBalance={allFiatBalanceByKaxaaCurrencyRateApi}
            currencyBalance={totalCurrencyBalanceInKaxaa}
            activeCurrency={activeCurrency}
            handleReceive={this.handleReceive}
            handleWithdraw={this.handleWithdrawFirstAsset}
            isFetching={isBalanceFetching}
            type="wallet"
            currency="kax"
            multisigPendingCount={multisigPendingCount}
            activeComponentNum={activeComponentNum}
          />
        )}
      >

        <div className="get-kaxaa--modal" styleName={cx({
          'modal-overlay': true,
        })}>
          <div styleName={cx({
            'modal': true,
          })}>
            <div styleName="header">
              <p styleName="title">
                Withdraw Kax Token
                <img src={TokenIcon} style={{ width: '40px', marginLeft: '10px' }} alt='icon-kaxaa token' />
              </p>
              {/* <CloseIcon styleName="closeButton" onClick={this.handleClose} data-testid="modalCloseIcon" /> */}
            </div>
            <div styleName={cx({
              'content': true,
            })}>

              <div className='card-item--holder-new' styleName={cx({
                'currenciesWrapper': true,
              })}>

                <label className='transaction-method-title'>Select your transaction method</label>

                <p className='note-line'><strong>Important: </strong> *Kaxaa (KAX) tokens must be converted to USDC (Polygon) first, then USDC (Polygon) tokens can be withdrawn (off-ramp).</p>

                <div styleName="card" className='card-item' onClick={() => {
                  window.location.href = '/#/kax/transak/off-ramp'
                }}>
                  {/*<Link to={'/kax/ach'} className='stretched-link'></Link>*/}
                  <div>
                    <img width={'50px'} height={'50px'} className='icon' src={BankIcon} alt='icon' />
                  </div>
                  <div className="info">
                    <p className='title'>ACH/Debit</p>
                    <span>Convert USDC to fiat</span>
                  </div>
                  <div>
                    <a className="btn btn-primary-custom">
                      Click Here
                    </a>
                  </div>
                </div>
                <div styleName="card" className='card-item' onClick={() => {
                  window.location.href = '/#/exchange/quick/{matic}kaxaa-to-{matic}usdc'
                }}>
                  {/*<Link to={'/kax/quickSwap'} className='stretched-link'></Link>*/}
                  <div>
                    <img width={'50px'} height={'50px'} className='icon' src={QuickSwapIcon} alt='icon' />
                  </div>
                  <div className="info">
                    <p className='title'>QuickSwap</p>
                    <span>Exchange USDC, POL and KAXAA with minimum fee.</span>
                  </div>
                  <div>
                    <a className="btn btn-primary-custom">
                      Click Here
                    </a>
                  </div>
                </div>
                <div styleName="card" className='card-item' onClick={() => {
                  window.location.href = '/#/exchange/?currency=kaxaa'
                }}>
                  {/*<Link to={'/kax/rango'} className='stretched-link'></Link>*/}
                  <div>
                    <img width={'50px'} height={'50px'} className='icon' src={RangoIcon} alt='icon' />
                  </div>
                  <div className="info">
                    <p className='title'>Rango Chain Swap</p>
                    <span>Exchange and cryptocurrency you own to KAXAA</span>
                  </div>
                  <div>
                    <a className="btn btn-primary-custom">
                      Click Here
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    )
  }
}

export default injectIntl(SellIntro)
